import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";
import * as _ from "lodash";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { Loan, LoanPaymentDetail } from "../models/loan.model";

import "firebase/firestore";
import { AngularFireFunctions } from "@angular/fire/functions";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class LoanService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<Loan>;
  collRefRemind: AngularFirestoreCollection<LoanPaymentDetail>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
    private fns: AngularFireFunctions
  ) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getLoans(shopId: string, fromDate: Date, toDate: Date) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/loans`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("issueDate", ">=", fromDate)
      .where("issueDate", "<=", toDate)
      .orderBy("issueDate", "desc");

    return ref.get();
  }

  getLoansByMode(
    shopId: string,
    fromDate: Date,
    toDate: Date,
    isRemind: boolean
  ): AngularFirestoreCollection<Loan> {
    if (isRemind) {
      return this.db.collection(this.dbPath + `/${shopId}/loans`, (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("remindDate", ">=", fromDate)
          .where("remindDate", "<=", toDate)
          .orderBy("remindDate", "desc")
      );
    } else {
      return this.db.collection(this.dbPath + `/${shopId}/loans`, (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("issueDate", ">=", fromDate)
          .where("issueDate", "<=", toDate)
          .orderBy("issueDate", "desc")
      );
    }
  }

  getLoansByRemindDate(shopId: string, fromDate: Date, toDate: Date) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/loans`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("remindDate", ">=", fromDate)
      .where("remindDate", "<=", toDate)
      .orderBy("remindDate", "desc");

    return ref.get();
  }

  getLoansByRemindDatePast(shopId: string) {
    const toDate: Date = moment().add(-1, "days").endOf("day").toDate();
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/loans`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("isClosed", "==", false)
      .where("remindDate", "<=", toDate)
      .orderBy("remindDate", "desc");

    return ref.get();
  }

  getLoansByCustomer(
    shopId: string,
    customerId: string,
    fromDate: Date,
    toDate: Date
  ): AngularFirestoreCollection<Loan> {
    return this.db.collection(this.dbPath + `/${shopId}/loans`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("customerId", "==", customerId)
        .where("issueDate", ">=", fromDate)
        .where("issueDate", "<=", toDate)
        .orderBy("issueDate", "desc")
    );
  }

  getLoansByProduct(
    shopId: string,
    productId: string,
    fromDate: Date,
    toDate: Date
  ): AngularFirestoreCollection<Loan> {
    return this.db.collection(this.dbPath + `/${shopId}/loans`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("productId", "==", productId)
        .where("issueDate", ">=", fromDate)
        .where("issueDate", "<=", toDate)
        .orderBy("issueDate", "desc")
    );
  }

  getLoansByIssueDate(
    shopId: string,
    type: string,
    issueDate: Date
  ): AngularFirestoreCollection<Loan> {
    return this.db.collection(this.dbPath + `/${shopId}/loans`, (ref) => {
      let query: CollectionReference | Query = ref;
      let year = issueDate.getFullYear();
      let month = issueDate.getMonth() + 1;
      let day = issueDate.getDate();
      console.log(`getLoansByIssueDate: ${day}/${month}/${year}`);

      query = query.where("isDeleted", "==", false);
      query = query.where("isActive", "==", true);
      query = query.where("issueDateYear", "==", year);
      query = query.where("issueDateMonth", "==", month);

      if (type === "day") {
        query = query.where("issueDateDay", "==", day);
      }

      query = query.orderBy("issueDate", "desc");

      return query;
    });
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/loans`)
      .doc(id)
      .valueChanges();
  }

  getLoan(shopId: string, id: string) {
    var db = firebase.default.firestore();
    var ref = db.collection(this.dbPath + `/${shopId}/loans`).doc(id);

    return ref.get();
  }

  create(loan: Loan): any {
    let obj = _.clone(loan);
    delete obj.id;

    // Object.keys(obj.customer).forEach((key) => {
    //   if (obj.customer[key as keyof Customer] === undefined) {
    //     delete obj.customer[key as keyof Customer];
    //   }
    // });

    // Object.keys(obj.product).forEach((key) => {
    //   if (obj.customer[key as keyof Product] === undefined) {
    //     delete obj.customer[key as keyof Product];
    //   }
    // });

    obj.customer = {
      fullName: loan.customer.fullName ? loan.customer.fullName : "",
      address: loan.customer.address ? loan.customer.address : "",
      mobile: loan.customer.mobile ? loan.customer.mobile : "",
      cardId: loan.customer.cardId ? loan.customer.cardId : "",
      cardIdDate: loan.customer.cardIdDate
        ? loan.customer.cardIdDate
        : new Date(),
    };

    obj.product = {
      barcode: loan.product.barcode ? loan.product.barcode : "",
      title: loan.product.title ? loan.product.title : "",
      description: loan.product.description ? loan.product.description : "",
      unitId: loan.product.unitId ? loan.product.unitId : "",
      categoryId: loan.product.categoryId ? loan.product.categoryId : "",
      categoryName: loan.product.categoryName ? loan.product.categoryName : "",
      colorId: loan.product.colorId ? loan.product.colorId : "",
      colorName: loan.product.colorName ? loan.product.colorName : "",
    };

    obj.issueDate = obj.issueDate ? new Date(obj.issueDate) : new Date();
    obj.issueDateYear = obj.issueDate.getFullYear();
    obj.issueDateMonth = obj.issueDate.getMonth() + 1;
    obj.issueDateDay = obj.issueDate.getDate();
    obj.issueDateWeekDay = obj.issueDate.getDay();
    obj.issueDateHours = obj.issueDate.getHours();
    obj.issueDateMinutes = obj.issueDate.getMinutes();
    obj.issueDateSeconds = obj.issueDate.getSeconds();

    obj.remindType = loan.remindType ? loan.remindType : "month"; //day/month/year
    obj.remindPaidNumber = obj.remindPaidNumber ? obj.remindPaidNumber : 1;
    obj.remindAmount = obj.remindAmount ? obj.remindAmount : 0;
    obj.remindDate = this.calculateRemindDate(obj);

    obj.groupId = obj.groupId ? obj.groupId : "";
    obj.groupName = obj.groupName ? obj.groupName : "";
    obj.note = obj.note ? obj.note : "";

    obj.detailAmount = obj.detailAmount ? obj.detailAmount : 0;
    obj.profitPercent = obj.profitPercent ? obj.profitPercent : 0;
    obj.profitAmount = obj.profitAmount ? obj.profitAmount : 0;
    obj.vatPercent = obj.vatPercent ? obj.vatPercent : 0;
    obj.vatAmount = obj.vatAmount ? obj.vatAmount : 0;
    obj.totalAmount = obj.totalAmount ? obj.totalAmount : 0;
    obj.totalPaidAmount = obj.totalPaidAmount ? obj.totalPaidAmount : 0;
    obj.totalProfit = obj.totalProfit ? obj.totalProfit : 0;

    obj.loanPaymentDetails =
      loan.loanPaymentDetails && loan.loanPaymentDetails.length > 0
        ? JSON.parse(JSON.stringify(loan.loanPaymentDetails))
        : [];

    obj.isClosed = false;
    obj.isActive = true;
    obj.isDeleted = false;
    obj.createdOn = new Date();
    obj.createdBy = this.userLogin.uid;
    obj.updatedOn = new Date();
    obj.updatedBy = this.userLogin.uid;
    obj.author = this.userLogin;
    obj.visibility = this.visibility;
    obj.timestamp = new Date().getTime();

    obj.shopId = obj.shopId ? obj.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(this.dbPath + `/${loan.shopId}/loans`);

    console.log("create loan:", obj);

    return this.collRef.add({ ...obj }).then((docRef) => {
      obj.id = docRef.id;
      delete obj.author;
      return obj;
    });
  }

  update(loan: Loan): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    loan.issueDate = loan.issueDate ? loan.issueDate : new Date();
    loan.issueDateYear = loan.issueDate.getFullYear();
    loan.issueDateMonth = loan.issueDate.getMonth() + 1;
    loan.issueDateDay = loan.issueDate.getDate();
    loan.issueDateWeekDay = loan.issueDate.getDay();
    loan.issueDateHours = loan.issueDate.getHours();
    loan.issueDateMinutes = loan.issueDate.getMinutes();
    loan.issueDateSeconds = loan.issueDate.getSeconds();

    loan.remindType = loan.remindType ? loan.remindType : "month"; //day/month/year

    if (!loan.isClosed) {
      loan.remindDate = this.calculateRemindDate(loan);
    }

    this.collRef = this.db.collection(this.dbPath + `/${loan.shopId}/loans`);

    console.log("update loan:", loan);
    // return this.collRef.doc(loan.id).update(JSON.parse(JSON.stringify(obj)));
    return this.collRef.doc(loan.id).update({
      issueDate: loan.issueDate,
      issueDateSeconds: loan.issueDateSeconds,
      issueDateMinutes: loan.issueDateMinutes,
      issueDateHours: loan.issueDateHours,
      issueDateDay: loan.issueDateDay,
      issueDateWeekDay: loan.issueDateWeekDay,
      issueDateMonth: loan.issueDateMonth,
      issueDateYear: loan.issueDateYear,
      code: loan.code ? loan.code : "",
      note: loan.note ? loan.note : "",
      tags: loan.tags ? loan.tags : [],
      status: loan.status ? loan.status : "",
      remindType: loan.remindType,
      groupId: loan.groupId,
      groupName: loan.groupName,

      detailAmount: loan.detailAmount ? loan.detailAmount : 0,
      profitPercent: loan.profitPercent ? loan.profitPercent : 0,
      profitAmount: loan.profitAmount ? loan.profitAmount : 0,
      vatPercent: loan.vatPercent ? loan.vatPercent : 0,
      vatAmount: loan.vatAmount ? loan.vatAmount : 0,
      totalAmount: loan.totalAmount ? loan.totalAmount : 0,
      totalPaidAmount: loan.totalPaidAmount ? loan.totalPaidAmount : 0,
      totalProfit: loan.totalProfit ? loan.totalProfit : 0,

      remindPaidNumber: loan.remindPaidNumber ? loan.remindPaidNumber : 1,
      remindAmount: loan.remindAmount ? loan.remindAmount : 0,
      remindDate: loan.remindDate,
      // lastRemindDate: loan.lastRemindDate,
      // nextRemindDate: loan.nextRemindDate,

      // isCancel: loan.isCancel,
      // isClosed: loan.isClosed,
      // isPrint: loan.isPrint,
      // noPrint: loan.noPrint,

      customerId: loan.customerId,
      customerName: loan.customer.fullName,
      customer: {
        fullName: loan.customer.fullName ? loan.customer.fullName : "",
        address: loan.customer.address ? loan.customer.address : "",
        mobile: loan.customer.mobile ? loan.customer.mobile : "",
        cardId: loan.customer.cardId ? loan.customer.cardId : "",
        cardIdDate: loan.customer.cardIdDate
          ? loan.customer.cardIdDate
          : new Date(),
      },

      productId: loan.productId,
      productName: loan.product.title,
      product: {
        barcode: loan.product.barcode ? loan.product.barcode : "",
        title: loan.product.title ? loan.product.title : "",
        description: loan.product.description ? loan.product.description : "",
        unitId: loan.product.unitId ? loan.product.unitId : "",
        categoryName: loan.product.categoryName
          ? loan.product.categoryName
          : "",
        colorId: loan.product.colorId ? loan.product.colorId : "",
        colorName: loan.product.colorName ? loan.product.colorName : "",
      },

      loanPaymentDetails:
        loan.loanPaymentDetails && loan.loanPaymentDetails.length > 0
          ? JSON.parse(JSON.stringify(loan.loanPaymentDetails))
          : [],

      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  updateRemindDate(loan: Loan): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    loan.remindDate = this.calculateRemindDate(loan);

    this.collRef = this.db.collection(this.dbPath + `/${loan.shopId}/loans`);

    console.log("update loan:", loan);

    return this.collRef.doc(loan.id).update({
      remindDate: loan.remindDate,
      remindPaidNumber: loan.remindPaidNumber ? loan.remindPaidNumber : 1,
      remindType: loan.remindType ? loan.remindType : "month",
      updatedBy: updatedBy,
      updatedOn: updatedOn,
      timestamp: new Date().getTime(),
    });
  }

  saveCustomerId(shopId: string, id: string, customerId: string) {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/loans`);
    return this.collRef.doc(id).update({
      customerId: customerId,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  saveProductId(shopId: string, id: string, productId: string) {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/loans`);
    return this.collRef.doc(id).update({
      productId: productId,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string) {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/loans`);
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  closed(shopId: string, id: string, isClosed: boolean) {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/loans`);
    return this.collRef.doc(id).update({
      isClosed: isClosed,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  //payment reminder notification
  createPaymentRemind(loanPayment: LoanPaymentDetail): any {
    let obj = _.clone(loanPayment);
    delete obj.id;

    Object.keys(obj.loan).forEach((key) => {
      if (obj.loan[key as keyof Loan] === undefined) {
        delete obj.loan[key as keyof Loan];
      }
    });

    obj.loan = JSON.parse(JSON.stringify(obj.loan));

    obj.issueDate = obj.issueDate ? obj.issueDate : new Date();
    obj.issueDateYear = obj.issueDate.getFullYear();
    obj.issueDateMonth = obj.issueDate.getMonth() + 1;
    obj.issueDateDay = obj.issueDate.getDate();
    obj.issueDateWeekDay = obj.issueDate.getDay();
    obj.issueDateHours = obj.issueDate.getHours();
    obj.issueDateMinutes = obj.issueDate.getMinutes();
    obj.issueDateSeconds = obj.issueDate.getSeconds();

    obj.isPaid = !!obj.isPaid;
    obj.paymentDate = obj.paymentDate ? obj.paymentDate : obj.issueDate;
    obj.amount = obj.amount ? obj.amount : 0;
    obj.profitAmount = obj.profitAmount ? obj.profitAmount : 0;
    obj.comment = obj.comment ? obj.comment : "";

    obj.isActive = true;
    obj.isDeleted = false;
    obj.createdOn = new Date();
    obj.createdBy = this.userLogin.uid;
    obj.updatedOn = new Date();
    obj.updatedBy = this.userLogin.uid;
    obj.author = this.userLogin;
    obj.visibility = this.visibility;
    obj.timestamp = new Date().getTime();

    obj.shopId = obj.shopId ? obj.shopId : this.userLogin.shopId;

    const remindId =
      moment(obj.issueDate).format("YYYY-MM-DD") + "---" + obj.loanId;
    const remindRef = this.db.doc(
      `/shops/${obj.shopId}/loan-reminds/${remindId}`
    );

    obj = JSON.parse(JSON.stringify(obj));
    obj.issueDate = moment(obj.issueDate).toDate();
    console.log("create loan-reminds:", obj);

    return remindRef
      .set(obj, {
        merge: true,
      })
      .then((docRef) => {
        obj.id = remindId;
        delete obj.author;
        return obj;
      });
  }

  saveLoanRemindPaid(loanPayment: LoanPaymentDetail) {
    console.log(
      "🚀 ~ LoanService ~ saveLoanRemindPaid ~ loanPayment:",
      loanPayment
    );
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRefRemind = this.db.collection(
      this.dbPath + `/${loanPayment.shopId}/loan-reminds`
    );

    return this.collRefRemind.doc(loanPayment.id).update({
      paymentDate: loanPayment.paymentDate
        ? loanPayment.paymentDate
        : loanPayment.issueDate,
      isPaid: loanPayment.isPaid,
      amount: loanPayment.amount
        ? parseFloat(loanPayment.amount.toString())
        : 0,
      comment: loanPayment.comment ? loanPayment.comment : "",
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  deleteLoanRemindPaid(shopId: string, id: string) {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRefRemind = this.db.collection(
      this.dbPath + `/${shopId}/loan-reminds`
    );

    return this.collRefRemind.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  getLoanReminds(shopId: string, fromDate: Date, toDate: Date) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/loan-reminds`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("issueDate", ">=", fromDate)
      .where("issueDate", "<=", toDate)
      .orderBy("issueDate", "desc");

    return ref.get();
  }

  getLoanRemindsByRemindDate(
    shopId: string,
    fromDate: Date,
    toDate: Date,
    isPaid: boolean
  ) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/loan-reminds`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("issueDate", ">=", fromDate)
      .where("issueDate", "<=", toDate)
      .where("isPaid", "==", isPaid)
      .orderBy("issueDate", "asc");

    return ref.get();
  }

  getLoanRemindsByPaymentDate(shopId: string, fromDate: Date, toDate: Date) {
    console.log(
      "🚀 ~ LoanService ~ getLoanRemindsByPaymentDate ~ fromDate:",
      fromDate
    );

    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/loan-reminds`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("paymentDate", ">=", fromDate)
      .where("paymentDate", "<=", toDate)
      .where("isPaid", "==", true)
      .orderBy("paymentDate", "desc");

    return ref.get();
  }

  getLoanRemindsByLoan(shopId: string, loanId: string) {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/loan-reminds`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("loanId", "==", loanId)
      .orderBy("issueDate", "desc");

    return ref.get();
  }

  calculateRemindDate(loan: Loan): Date {
    let remindDate = new Date();

    const remindPaidNumber = loan.remindPaidNumber ? loan.remindPaidNumber : 1;

    const remindType = ["day", "week", "month", "year"].includes(
      loan.remindType
    )
      ? loan.remindType
      : "month";

    remindDate = this.getNextRenewalDate(
      loan.issueDate,
      remindType as "day" | "week" | "month" | "year",
      remindPaidNumber
    );
    return remindDate;
  }

  getNextRenewalDate(
    receivedDate: Date,
    type: "day" | "week" | "month" | "year",
    amount: number
  ): Date {
    // let nextDate = moment(receivedDate, "DD/MM/YYYY").add(amount, type);
    let nextDate = moment(receivedDate).add(amount, type);
    const today = moment(); // Lấy ngày hiện tại

    // Nếu ngày gia hạn tiếp theo ở quá khứ, tiếp tục cộng thêm cho đến khi nó ở tương lai
    while (nextDate.isBefore(today, "day")) {
      nextDate.add(amount, type);
    }

    // return nextDate.format("DD/MM/YYYY");
    return nextDate.endOf("day").toDate();
  }
}
